export default __webpack_public_path__ + "static/media/expl_15_DE.16d9e159.png";